import { FormTypes } from '@oneblink/types'
import { submissionService } from '@oneblink/apps-react'
import { toast } from 'react-toastify'
import { findElement, replaceElement } from '../../definition-manipulation'

export function setHasPricingLookupRunInitial(
  form: FormTypes.Form,
  {
    elementName = 'hasPricingLookupRunInfo',
    buttonName = 'Calculate charges',
  }: { elementName?: string; buttonName?: string },
) {
  //hidden by the console if 'yes' or 'never'
  const hasPricingLookupRunInfo = findElement(form, elementName)
  if (
    hasPricingLookupRunInfo &&
    hasPricingLookupRunInfo.value.type === 'html'
  ) {
    hasPricingLookupRunInfo.parent.elements = replaceElement(
      hasPricingLookupRunInfo.parent.elements || [],
      hasPricingLookupRunInfo.value,
      {
        ...hasPricingLookupRunInfo.value,
        defaultValue: `<div class="has-text-danger ob-error__text">Chargeable items have changed, please click '${buttonName}'</div>`,
      },
    )
  }
}

export function updateHasPricingLookupRun({
  submission,
  currentHash,
  newHash,
  updateHash,
}: {
  submission: Record<string, unknown>
  currentHash: string | undefined
  newHash: string
  updateHash: (hash: string) => void
}) {
  if (currentHash !== newHash) {
    updateHash(newHash)

    if (currentHash && submission.hasPricingLookupRun__hidden === 'yes') {
      submission.hasPricingLookupRun__hidden = 'no'
    }
  }
}

export function verifyPricingLookupHasRun({
  newFormSubmission,
  calculateName = 'charges',
}: {
  newFormSubmission: submissionService.NewFormSubmission
  calculateName?: string
}) {
  const hasPricingLookupRun =
    newFormSubmission.submission.hasPricingLookupRun__hidden

  if (hasPricingLookupRun !== 'yes') {
    /* 
        if submission is a clarification request it is ok if the lookup has never run.
        if the model has changed in a clarification request though then hasPricingLookupRun will be 'no' 
          and the below will fire
    */
    toast.error(`Please calculate ${calculateName} before submitting again`, {
      position: 'bottom-right',
      hideProgressBar: true,
    })
    return false
  }
  return true
}
